import { Col, Label, RadioContainer, Rating } from '../../../../../../CommonComponents'
import PopupDialogbox from '../../PopupDilalogBox/PopupDilalogBox';
import './AssetInformation.scss'
import { Tooltip } from 'client/CommonComponents';
import { formatPrice } from 'utils';
import { CONSTANTS } from "client/utils/constants";
import Moment from 'moment';
import AttachmentLinkContainer from 'client/Components/OrderManagement/ApprovalOrder/LeadrOrder/ItemDetail/AttachmentLink/AttachmentLink-Container';

//common information for all the request types for assets, unit, vin/serial, lincese plate, frs item id
const CommonInformation = (props?: any) => {

  const {assetOrderByIdItem, frsRequired} = props;
  return (
    <>
      <div>
        <Label data-attribute="AssetInformation_Default_Label">Asset #</Label>
        <Tooltip content={assetOrderByIdItem?.assetNo || '-'} data-attribute="AssetInformation_Default_Tooltip">
          <div className="content" >{assetOrderByIdItem?.assetNo || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetInformation_Default_Label_2">Unit #</Label>
        <Tooltip content={assetOrderByIdItem?.equipmentNo || '-'} data-attribute="AssetInformation_Default_Tooltip_2">
          <div className="content" >{assetOrderByIdItem?.equipmentNo || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetInformation_Default_Label_3">{assetOrderByIdItem?.assetType == "vehicle" ? "VIN #" : "Serial #"} </Label>
        <Tooltip content={assetOrderByIdItem?.vinSerialNumber || '-'} data-attribute="AssetInformation_Default_Tooltip_3">
          <div className="content" >{assetOrderByIdItem?.vinSerialNumber || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetInformation_Default_Label_4">License Plate #</Label>
        <Tooltip content={assetOrderByIdItem?.licenseNumber || '-'} data-attribute="AssetInformation_Default_Tooltip_4">
          <div className="content" >{assetOrderByIdItem?.licenseNumber || '-'}</div>
        </Tooltip>
      </div>
      {frsRequired ? <div>
        <Label data-attribute="AssetInformation_Default_Label_5">FRS Item ID #</Label>
        <Tooltip content={assetOrderByIdItem?.frsOrderNumberItemNo || '-'} data-attribute="AssetInformation_Default_Tooltip_5">
          <div className="content" >{assetOrderByIdItem?.frsOrderNumberItemNo || '-'}</div>
        </Tooltip>
      </div> : null}
    </>
  )
}



const AssetInformation = (props?: any) => {
  const transferOrderByIdData = props?.transferOrderByIdData;
  const assetOrderByIdItem = props?.assetOrderByIdItem;
  const assetOrderByIdIndex = props?.assetOrderByIdIndex;
  const detailsByIdItem = props?.detailsByIdItem;
  const itemLevelApproverActionChange = props?.itemLevelApproverActionChange;
  const isValidForPenaltyFee = props?.isValidForPenaltyFee;
  const requesttype = props?.requesttype;
  const afeOrderByIdData = props?.afeOrderByIdData;

  const OdometerValueChange = () => {
    if (assetOrderByIdItem?.odometerPHourMeter != null) {
      return (assetOrderByIdItem?.odometerPHourMeter)
    } else {
      return ("-")
    }
  }
  return (
    <div className="itemDetails mt-0">
      <div className={`asset-information ${props?.getRequestStyle(assetOrderByIdItem?.transferDispoReactivationAssetDetailId)}`}>
        {requesttype != CONSTANTS.AFEREQUEST &&
        <>
        {/* Transfer Asset Detail */}
        {detailsByIdItem?.orderRequestType == CONSTANTS.TRANSFER_REQUEST ? <div className='Transfer-asset'>
          <CommonInformation assetOrderByIdItem={assetOrderByIdItem} frsRequired />
          <div className='showStatus'></div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_6">Color</Label>
            <Tooltip content={assetOrderByIdItem?.color || '-'} data-attribute="AssetInformation_Default_Tooltip_6">
              <div className="content" >{assetOrderByIdItem?.color || '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_7">Year</Label>
            <Tooltip content={assetOrderByIdItem?.year || '-'} data-attribute="AssetInformation_Default_Tooltip_7">
              <div className="content" >{assetOrderByIdItem?.year || '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_8">Description</Label>
            <Tooltip content={assetOrderByIdItem?.description || '-'} data-attribute="AssetInformation_Default_Tooltip_8">
              <div className="content" >{assetOrderByIdItem?.description || '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_9">Equipment Status</Label>
            <Tooltip content={assetOrderByIdItem?.equipmentStatus || '-'} data-attribute="AssetInformation_Default_Tooltip_9">
              <div className="content" >{assetOrderByIdItem?.equipmentStatus || '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_10">Equipment Class</Label>
            <Tooltip content={assetOrderByIdItem?.equipmentClass || '-'} data-attribute="AssetInformation_Default_Tooltip_10">
              <div className="content" >{assetOrderByIdItem?.equipmentClass || '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_11">Net Booked Value</Label>
            <Tooltip content={assetOrderByIdItem?.netBookedValue != null ? `$${formatPrice(assetOrderByIdItem?.netBookedValue, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_11">
              <div className="content" >{assetOrderByIdItem?.netBookedValue != null ? `$${formatPrice(assetOrderByIdItem?.netBookedValue, 2)}` : '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_12">Monthly Payment</Label>
            <Tooltip content={assetOrderByIdItem?.monthlyPaymentAmt != null ? `$${formatPrice(assetOrderByIdItem?.monthlyPaymentAmt, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_12">
              <div className="content" >{assetOrderByIdItem?.monthlyPaymentAmt != null ? `$${formatPrice(assetOrderByIdItem?.monthlyPaymentAmt, 2)}` : '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_13">Months Remaining</Label>
            <Tooltip content={assetOrderByIdItem?.monthRemaining != null ? assetOrderByIdItem?.monthRemaining : '-'} data-attribute="AssetInformation_Default_Tooltip_13">
              <div className="content" >{assetOrderByIdItem?.monthRemaining != null ? assetOrderByIdItem?.monthRemaining : '-'}</div>
            </Tooltip>
          </div>
          <div>
            {assetOrderByIdItem?.assetType !== CONSTANTS.TRAILERS && <>
              <Label data-attribute="AssetInformation_Default_Label_14">{assetOrderByIdItem?.assetType == "vehicle" ? "Mileage" : assetOrderByIdItem?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
              <Tooltip content={OdometerValueChange()} data-attribute="AssetInformation_Default_Tooltip_14">
                <div className="content" >{OdometerValueChange()}</div>
              </Tooltip>
            </>}
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_15">Overall Condition</Label>
            <Rating rating={assetOrderByIdItem?.overallConditionRating} className='overall-rating mb-2' readOnly={true}  data-attribute="AssetInformation_Default_Rating" />
          </div>
          <div className='mb-sm-0 mb-3'>
            <AttachmentLinkContainer
              item={assetOrderByIdItem}
              index={assetOrderByIdIndex}
              itemLevel={"Asset"}
            />
          </div>
          <div className="Overall_Condtion_Comment">
            <Label data-attribute="AssetInformation_Default_Label_16">Overall Condition Comment</Label>
            <Tooltip content={assetOrderByIdItem?.overallConditionComments || '-'} data-attribute="AssetInformation_Default_Tooltip_15">
              <div className="content overall-content" >{assetOrderByIdItem?.overallConditionComments || '-'}</div>
            </Tooltip>
          </div>
        </div> :''
        }

        {/* Disposition Asset Detail */}
        {detailsByIdItem.orderRequestType == CONSTANTS?.DISPOSITION_REQUEST ? <div className='Disposition-asset'>
          <CommonInformation assetOrderByIdItem={assetOrderByIdItem} frsRequired />
          <div className='showStatus'></div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_17">Year</Label>
            <Tooltip content={assetOrderByIdItem?.year || '-'} data-attribute="AssetInformation_Default_Tooltip_16">
              <div className="content" >{assetOrderByIdItem?.year || '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_18">Color</Label>
            <Tooltip content={assetOrderByIdItem?.color || '-'} data-attribute="AssetInformation_Default_Tooltip_17">
              <div className="content" >{assetOrderByIdItem?.color || '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_19">Equipment Status</Label>
            <Tooltip content={assetOrderByIdItem?.equipmentStatus || '-'} data-attribute="AssetInformation_Default_Tooltip_18">
              <div className="content" >{assetOrderByIdItem?.equipmentStatus || '-'}</div>
            </Tooltip>
          </div>
          <div>
            {assetOrderByIdItem?.assetType !== CONSTANTS.TRAILERS && <>
              <Label data-attribute="AssetInformation_Default_Label_20">{assetOrderByIdItem?.assetType == "vehicle" ? "Mileage" : assetOrderByIdItem?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
              <Tooltip content={OdometerValueChange()} data-attribute="AssetInformation_Default_Tooltip_19">
                <div className="content" >{OdometerValueChange()}</div>
              </Tooltip>
            </>}
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_21">Net Booked Value</Label>
            <Tooltip content={assetOrderByIdItem?.netBookedValue != null ? `$ ${formatPrice(assetOrderByIdItem?.netBookedValue, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_20">
              <div className="content" >{assetOrderByIdItem?.netBookedValue != null ? `$ ${formatPrice(assetOrderByIdItem?.netBookedValue, 2)}` : '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_22">Monthly Payment</Label>
            <Tooltip content={assetOrderByIdItem?.monthlyPaymentAmt != null ? `$ ${formatPrice(assetOrderByIdItem?.monthlyPaymentAmt, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_21">
              <div className="content" >{assetOrderByIdItem?.monthlyPaymentAmt != null ? `$ ${formatPrice(assetOrderByIdItem?.monthlyPaymentAmt, 2)}` : '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_23">Months Remaining</Label>
            <Tooltip content={assetOrderByIdItem?.monthRemaining != null ? assetOrderByIdItem?.monthRemaining : '-'} data-attribute="AssetInformation_Default_Tooltip_22">
              <div className="content" >{assetOrderByIdItem?.monthRemaining != null ? assetOrderByIdItem?.monthRemaining : '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_24">Estimated Disposition Price</Label>
            <Tooltip content={assetOrderByIdItem?.estimatedDispoValue != null ? `$ ${formatPrice(assetOrderByIdItem?.estimatedDispoValue, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_23">
              <div className="content" >{assetOrderByIdItem?.estimatedDispoValue != null ? `$ ${formatPrice(assetOrderByIdItem?.estimatedDispoValue, 2)}` : '-'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_25">Description</Label>
            <Tooltip content={assetOrderByIdItem?.description || '-'} data-attribute="AssetInformation_Default_Tooltip_24">
              <div className="content" >{assetOrderByIdItem?.description || '-'}</div>
            </Tooltip>
          </div>

          <div>{
            (isValidForPenaltyFee(detailsByIdItem?.dispositionType) && assetOrderByIdItem?.dispositionPenaltyFee > 0) ?
              <><Label data-attribute="AssetInformation_Default_Label_26">Write Off Penalty Fee</Label>
                <Tooltip content={assetOrderByIdItem?.dispositionPenaltyFee ? `$${formatPrice(assetOrderByIdItem?.dispositionPenaltyFee, 2)}` : '$0.00'} data-attribute="AssetInformation_Default_Tooltip_25">
                  <div className="content" >{assetOrderByIdItem?.dispositionPenaltyFee ? `$${formatPrice(assetOrderByIdItem?.dispositionPenaltyFee, 2)}` : '$0.00'}</div>
                </Tooltip></>
              : ''
          }</div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_27">Overall Condition</Label>
            <Rating rating={assetOrderByIdItem?.overallConditionRating} className='overall-rating mb-2' readOnly={true}  data-attribute="AssetInformation_Default_Rating_2" />
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_28">Replacement Fleet Asset Order #</Label>
            <Tooltip content={assetOrderByIdItem?.replacementFleetAssetOrderNo || 'N/A'} data-attribute="AssetInformation_Default_Tooltip_26">
              <div className="content" >{assetOrderByIdItem?.replacementFleetAssetOrderNo || 'N/A'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_29">Replacement Fleet Asset #</Label>
            <Tooltip content={assetOrderByIdItem?.replacementFleetAssetNo || 'N/A'} data-attribute="AssetInformation_Default_Tooltip_27">
              <div className="content" >{assetOrderByIdItem?.replacementFleetAssetNo || 'N/A'}</div>
            </Tooltip>
          </div>
          <div>
            <Label data-attribute="AssetInformation_Default_Label_30">Equipment Class</Label>
            <Tooltip content={assetOrderByIdItem?.equipmentClass || '-'} data-attribute="AssetInformation_Default_Tooltip_28">
              <div className="content" >{assetOrderByIdItem?.equipmentClass || '-'}</div>
            </Tooltip>
          </div>
          <div className='mb-sm-0 mb-3'>
            <AttachmentLinkContainer
              item={assetOrderByIdItem}
              index={assetOrderByIdIndex}
              itemLevel={"Asset"}
            />
          </div>
          {assetOrderByIdItem?.showAssetStatus ?
            <div>
              <div className="Asset_status_details">
                <Label data-attribute="AssetInformation_Default_Label_31">Asset Status</Label>
                <Tooltip content={assetOrderByIdItem?.assetStatus || '-'} data-attribute="AssetInformation_Default_Tooltip_29">
                  <div className="content overall-content" >{assetOrderByIdItem?.assetStatus || '-'}</div>
                </Tooltip>
              </div>
              {/* <div className="Asset_status_tooltip">
                {
                  (detailsByIdItem?.assets?.length > 1 || (transferOrderByIdData?.transferDisposeReactivationDetails?.length > 1)) &&
                  <div className='mb-sm-3 mb-3 radio-approvaBtns'><RadioContainer selectedKey={props?.selectedOption ?? ''} options={props?.approverActionList} onChange={itemLevelApproverActionChange} id={assetOrderByIdIndex}  data-attribute="AssetInformation_Default_Radio" /></div>
                }
              </div> */}

            </div>

            : null}
          <div className="Overall_Condtion_Comment">
            <Label data-attribute="AssetInformation_Default_Label_32">Overall Condition Comment</Label>
            <Tooltip content={assetOrderByIdItem?.overallConditionComments || '-'} data-attribute="AssetInformation_Default_Tooltip_30">
              <div className="content overall-content" >{assetOrderByIdItem?.overallConditionComments || '-'}</div>
            </Tooltip>
          </div>
        </div> : ''
        }
        {/* Reactivation Asset Detail */}
        {
          detailsByIdItem?.orderRequestType == CONSTANTS.REACTIVATION_REQUEST ? <div className='Reactivation-asset'>
            <CommonInformation assetOrderByIdItem={assetOrderByIdItem} />
            <div>
              <Label data-attribute="AssetInformation_Default_Label_33">Current License Plate #</Label>
              <Tooltip content={assetOrderByIdItem?.currentLicensePlateNo || '-'} data-attribute="AssetInformation_Default_Tooltip_31">
                <div className="content" >{assetOrderByIdItem?.currentLicensePlateNo || '-'}</div>
              </Tooltip>
            </div>
            <div className='showStatus'></div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_34">Color</Label>
              <Tooltip content={assetOrderByIdItem?.color || '-'} data-attribute="AssetInformation_Default_Tooltip_32">
                <div className="content" >{assetOrderByIdItem?.color || '-'}</div>
              </Tooltip>
            </div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_35">Year</Label>
              <Tooltip content={assetOrderByIdItem?.year || '-'} data-attribute="AssetInformation_Default_Tooltip_33">
                <div className="content" >{assetOrderByIdItem?.year || '-'}</div>
              </Tooltip>
            </div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_36">Make</Label>
              <Tooltip content={assetOrderByIdItem?.make || '-'} data-attribute="AssetInformation_Default_Tooltip_34">
                <div className="content" >{assetOrderByIdItem?.make || '-'}</div>
              </Tooltip>
            </div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_37">Model</Label>
              <Tooltip content={assetOrderByIdItem?.model || '-'} data-attribute="AssetInformation_Default_Tooltip_35">
                <div className="content" >{assetOrderByIdItem?.model || '-'}</div>
              </Tooltip>
            </div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_38">FRS Item ID #</Label>
              <Tooltip content={assetOrderByIdItem?.frsOrderNumberItemNo || '-'} data-attribute="AssetInformation_Default_Tooltip_36">
                <div className="content" >{assetOrderByIdItem?.frsOrderNumberItemNo || '-'}</div>
              </Tooltip>
            </div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_39">Description</Label>
              <Tooltip content={assetOrderByIdItem?.description || '-'} data-attribute="AssetInformation_Default_Tooltip_37">
                <div className="content" >{assetOrderByIdItem?.description || '-'}</div>
              </Tooltip>
            </div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_40">Equipment Status</Label>
              <Tooltip content={assetOrderByIdItem?.equipmentStatus || '-'} data-attribute="AssetInformation_Default_Tooltip_38">
                <div className="content" >{assetOrderByIdItem?.equipmentStatus || '-'}</div>
              </Tooltip>
            </div>
            {assetOrderByIdItem?.assetType !== CONSTANTS.TRAILERS &&
              <div>
                <Label data-attribute="AssetInformation_Default_Label_41">{assetOrderByIdItem?.assetType == "vehicle" ? "Mileage" : assetOrderByIdItem?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
                <Tooltip content={OdometerValueChange()} data-attribute="AssetInformation_Default_Tooltip_39">
                  <div className="content" >{OdometerValueChange()}</div>
                </Tooltip>
              </div>
            }
            <div>
              <Label data-attribute="AssetInformation_Default_Label_42">Disp Cost Center</Label>
              <Tooltip content={assetOrderByIdItem?.disposeCostCenter || '-'} data-attribute="AssetInformation_Default_Tooltip_40">
                <div className="content" >{assetOrderByIdItem?.disposeCostCenter || '-'}</div>
              </Tooltip>
            </div>
            <div>
              <Label data-attribute="AssetInformation_Default_Label_43">Dispose Date</Label>
              <Tooltip content={assetOrderByIdItem?.disposalDate != null ? Moment(assetOrderByIdItem?.disposalDate).format("MM/DD/YYYY") : "-"} data-attribute="AssetInformation_Default_Tooltip_41">
                <div className="content" >{assetOrderByIdItem?.disposalDate != null ? Moment(assetOrderByIdItem?.disposalDate).format("MM/DD/YYYY") : "-"}</div>
              </Tooltip>
            </div>
            <div className={assetOrderByIdItem?.assetType == CONSTANTS.TRAILERS ? 'removed-field' : ''}>
              <Label data-attribute="AssetInformation_Default_Label_44">Gain/Loss</Label>
              <Tooltip content={assetOrderByIdItem?.gainLoss != null ? assetOrderByIdItem?.gainLoss?.toString().includes('-') ? '$ (' + (formatPrice(assetOrderByIdItem?.gainLoss, 2)) + ')' : `$ ${formatPrice(assetOrderByIdItem?.gainLoss, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_42">
                <div className="content" >{assetOrderByIdItem?.gainLoss != null ? assetOrderByIdItem?.gainLoss?.toString().includes('-') ? '$ (' + (formatPrice(assetOrderByIdItem?.gainLoss, 2)) + ')' : `$ ${formatPrice(assetOrderByIdItem?.gainLoss, 2)}` : '-'}</div>
              </Tooltip>
            </div>
            <div className={assetOrderByIdItem?.assetType == CONSTANTS.TRAILERS ? 'removed-field mb-3' : 'mb-3'}>
              <AttachmentLinkContainer
                item={assetOrderByIdItem}
                index={assetOrderByIdIndex}
                itemLevel={"Asset"}
              />
            </div>
            <div className={assetOrderByIdItem?.assetType == CONSTANTS.TRAILERS ? 'removed-field' : ''}>
              <Label data-attribute="AssetInformation_Default_Label_45">Comments</Label>
              <Tooltip content={assetOrderByIdItem?.comments != null ? assetOrderByIdItem?.comments : '-'} data-attribute="AssetInformation_Default_Tooltip_43">
                <div className="content" >{assetOrderByIdItem?.comments != null ? assetOrderByIdItem?.comments : '-'}</div>
              </Tooltip>
            </div>
          </div> :''
        }
        </>
      }
        {
           requesttype == CONSTANTS.AFEREQUEST ? 
           <div className="p-3 afeorder_content">
                    <Col xl={12}>
                        <div className='row'>
                            <Col xl={9} md={12}>
                                <div className="row">
                                  {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP && 
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6}>
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.unitNumber ?? '-'} data-attribute="AssetInformation_Default_Tooltip_44">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_46">Unit #</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.unitNumber ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP &&
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6}>
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.year ?? '-'} data-attribute="AssetInformation_Default_Tooltip_45">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_47">Year</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.year ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP && 
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.eqStatus ?? '-'} data-attribute="AssetInformation_Default_Tooltip_46">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_48">Equipment Status</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.eqStatus ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP &&
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.eqClass ?? '-'} data-attribute="AssetInformation_Default_Tooltip_47">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_49">Equipment Class</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.eqClass ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP &&
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.vinSerialNumber ?? '-'} data-attribute="AssetInformation_Default_Tooltip_48">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_50">VIN / Serial #</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.vinSerialNumber ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP &&
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.licenseNumber ?? '-'} data-attribute="AssetInformation_Default_Tooltip_49">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_51">License #</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.licenseNumber ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP &&
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (                                   
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={formatPrice(afeOrderByIdData?.afeDetail?.afeAssetDetail?.netBookedValue, 2) ?? '$ 0.00'} data-attribute="AssetInformation_Default_Tooltip_50">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_52">Net Booked Value</Label>
                                                <span>$ {formatPrice(afeOrderByIdData?.afeDetail?.afeAssetDetail?.netBookedValue, 2) ?? '$ 0.00'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP &&
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={formatPrice(afeOrderByIdData?.afeDetail?.afeAssetDetail?.cost, 2) ?? '$ 0.00'} data-attribute="AssetInformation_Default_Tooltip_51">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_53">Cost</Label>
                                                <span>$ {formatPrice(afeOrderByIdData?.afeDetail?.afeAssetDetail?.cost, 2) ?? '$ 0.00'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP &&
                                    afeOrderByIdData?.afeDetail?.afeType !== CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.description ?? '-'} data-attribute="AssetInformation_Default_Tooltip_52">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_54">Description</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.description ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType == CONSTANTS.FLEET_EQUIPMENT && (
                                    <Col xl={12} md={12} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairRequest === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairRequest ? 'Yes' : 'No'} data-attribute="AssetInformation_Default_Tooltip_53">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_55">Is this request for a repair of any kind</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairRequest === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairRequest ? 'Yes' : 'No'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}                                
                                  {afeOrderByIdData?.afeDetail?.afeType == CONSTANTS.FLEET_EQUIPMENT && (
                                    <Col xl={12} md={4} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairValueOver1500 === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairValueOver1500 ? 'Yes' : 'No'} data-attribute="AssetInformation_Default_Tooltip_54">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_56">Is the value of the repair over $1,500.00?</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairValueOver1500 === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isRepairValueOver1500 ? 'Yes' : 'No'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType == CONSTANTS.FLEET_EQUIPMENT && (
                                    <Col xl={12} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.isEfficiencyIncreased === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isEfficiencyIncreased ? 'Yes' : 'No'} data-attribute="AssetInformation_Default_Tooltip_55">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_57">Will the operating capacity or
                                                    efficiency of the asset be substantially
                                                    increased?</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.isEfficiencyIncreased === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isEfficiencyIncreased ? 'Yes' : 'No'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType == CONSTANTS.FLEET_EQUIPMENT && (
                                    <Col xl={12} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.isLifeExtendedOneYear === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isLifeExtendedOneYear ? 'Yes' : 'No'} data-attribute="AssetInformation_Default_Tooltip_56">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_58">Will the life of the asset be extended
                                                    ONE YEAR beyond the original useful
                                                    life?</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.isLifeExtendedOneYear === null ? '-' : afeOrderByIdData?.afeDetail?.afeAssetDetail?.isLifeExtendedOneYear ? 'Yes' : 'No'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>)}
                                    {afeOrderByIdData?.afeDetail?.afeType == CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                      <Col xl={3} md={6} className="pt-3">
                                          <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.leaseId ?? '-'} data-attribute="AssetInformation_Default_Tooltip_57">
                                              <div>
                                                  <Label data-attribute="AssetInformation_Default_Label_59">Lease ID #</Label>
                                                  <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.leaseId ?? '-'}</span>
                                              </div>
                                          </Tooltip>
                                      </Col>
                                    )}
                                    <Col xl={3} md={6} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.invoicedAmount ?? '-'} data-attribute="AssetInformation_Default_Tooltip_58">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_60">Quoted Amount</Label>
                                                <span>$ {formatPrice(afeOrderByIdData?.afeDetail?.afeAssetDetail?.invoicedAmount, 2) ?? '$ 0.00'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>
                                    {afeOrderByIdData?.afeDetail?.afeType == CONSTANTS.LEASEHOLD_IMPROVEMENTS && (
                                      <Col xl={6} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.leaseExpirationDate ? Moment(afeOrderByIdData?.afeDetail?.afeAssetDetail?.leaseExpirationDate).format('MM/DD/YYYY') : '-'} data-attribute="AssetInformation_Default_Tooltip_59">
                                          <div>
                                            <Label data-attribute="AssetInformation_Default_Label_61">Expected Lease Expiration Date - Include Extension or Renewal Options</Label>
                                            <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.leaseExpirationDate ? Moment(afeOrderByIdData?.afeDetail?.afeAssetDetail?.leaseExpirationDate).format('MM/DD/YYYY') : '-'}</span>
                                          </div>
                                        </Tooltip>
                                      </Col>
                                    )}
                                    <Col xl={12} className="pt-3">
                                        <Tooltip content={afeOrderByIdData?.afeDetail?.afeAssetDetail?.jeDescription ?? '-'} data-attribute="AssetInformation_Default_Tooltip_60">
                                            <div>
                                                <Label data-attribute="AssetInformation_Default_Label_62">Description and Justification Of Expenditure</Label>
                                                <span>{afeOrderByIdData?.afeDetail?.afeAssetDetail?.jeDescription ?? '-'}</span>
                                            </div>
                                        </Tooltip>
                                    </Col>
                                </div>
                            </Col>
                            <Col xl={12} className="pt-3">
                                <div>
                                    <Label data-attribute="AssetInformation_Default_Label_63">{afeOrderByIdData?.afeDetail?.afeType == CONSTANTS.FLEET_EQUIPMENT ? 'Branch Address Information' : 'Physical Address for Improvement'}</Label>
                                    <div>
                                        {(() => {
                                            const branch = afeOrderByIdData?.afeDetail?.afeAssetDetail?.branchAddressDetail;
                                            if (!branch) return '-';
                                            const addressLines = [];
                                            if (branch.addLine1) addressLines.push(branch.addLine1);
                                            if (branch.addLine2) addressLines.push(branch.addLine2);
                                            let cityStateZip = '';
                                            if (branch.assetCity) cityStateZip += branch.assetCity;
                                            if (branch.assetState) cityStateZip += (cityStateZip ? ', ' : '') + branch.assetState;
                                            if (branch.assetZip) cityStateZip += (cityStateZip ? ' ' : '') + branch.assetZip;
                                            return <>
                                                {addressLines.length > 0 && <div>{addressLines.join(', ')}</div>}
                                                {cityStateZip && <div>{cityStateZip}</div>}
                                            </>;
                                        })()}
                                    </div>
                                </div>
                            </Col>                           
                        </div>
                    </Col>
           </div>
                : null
        }

        {
          (detailsByIdItem?.assets?.length > 1 || (transferOrderByIdData?.transferDisposeReactivationDetails?.length > 1)) &&
          <div className='mb-sm-3 mb-3 radio-approvaBtns'><RadioContainer selectedKey={props?.selectedOption ?? ''} options={props?.approverActionList} onChange={itemLevelApproverActionChange} id={assetOrderByIdIndex}  data-attribute="AssetInformation_Default_Radio_2" /></div>
        }
        <PopupDialogbox hideDialog={!props?.Popupcontent.isDialogVisible} onDismiss={props?.closeDialogHandler} Popupcontent={props?.Popupcontent} popupOutlinebtnOnclick={props?.popupOutlinebtnOnclick} popupPrimarybtnOnclick={props?.popupPrimarybtnOnclick}  data-attribute="AssetInformation_Default_PopupDilalogBox" />
      </div>
    </div >
  )
}

export default AssetInformation;
